import type { Account } from "@money/shared";
import { formatCents } from "../lib/format";

export function AccountCard({
  account,
  onDelete,
  onTogglePrivate,
  busy,
}: {
  account: Account;
  onDelete?: (id: string) => void;
  onTogglePrivate?: (id: string, next: 0 | 1) => void;
  busy?: boolean;
}) {
  return (
    <div className="rounded-lg border border-slate-800 bg-slate-900/40 p-4 flex items-center justify-between gap-4">
      <div>
        <div className="text-xs uppercase tracking-wide text-slate-500">
          {account.institution} · {account.kind}
        </div>
        <div className="text-base font-medium flex items-center gap-2">
          {account.display_name}
          {account.private === 1 && (
            <span className="text-[10px] uppercase tracking-wide rounded bg-slate-700 text-slate-300 px-1.5 py-0.5">
              Private
            </span>
          )}
        </div>
        {onTogglePrivate && (
          <button
            onClick={() => onTogglePrivate(account.id, account.private === 1 ? 0 : 1)}
            disabled={busy}
            className="text-xs text-slate-500 hover:text-slate-300 mt-1 disabled:opacity-50"
          >
            {account.private === 1 ? "Make visible to AI" : "Hide from AI (private)"}
          </button>
        )}
      </div>
      <div className="text-right">
        <div className="text-lg font-semibold tabular-nums">
          {formatCents(account.balance_cents, account.currency)}
        </div>
        {onDelete && (
          <button
            onClick={() => onDelete(account.id)}
            className="text-xs text-slate-500 hover:text-rose-400 mt-1"
          >
            Delete
          </button>
        )}
      </div>
    </div>
  );
}
